export default __webpack_public_path__ + "static/media/react.4e0c9700.svg";